import "../scss/style.scss";
import $ from 'jquery';
import 'slick-carousel';
import 'jquery-match-height';
import 'lity';
import "./faq.js";
import "./highschool.js";
import "./lib/ofi.min.js";

jQuery(function ($) {

	// smooth scroll
	$(function () {
		var headerHeight = $('.header').outerHeight();
		var urlHash = location.hash;
		if (urlHash) {
			$('body,html').stop().scrollTop(0);
			setTimeout(function() {
				var target = $(urlHash);
				var position = target.offset().top - headerHeight;
				$('body,html').stop().animate({
					scrollTop: position
				}, 500);
			}, 100);
			return false;
		}
		$('a[href^="#"]').click(function() {
			var href = $(this).attr("href");
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - headerHeight;
			$('body,html').stop().animate({
				scrollTop: position
			}, 500);
			return false;
		});
	});

  // SP nav
	$(function () {
		$('.js-nav-bt').on('click', function () {
			if ($('.js-nav-content').hasClass('close')) {
				$(".js-nav-content").removeClass('close');
				$(".header__bg").removeClass('close');
				$(this).removeClass('close');
			} else {
				$(".js-nav-content").addClass('close');
				$(".header__bg").addClass('close');
				$(this).addClass('close');
			}
		});
		$('.js-nav-bt.close, .header__bg').on('click', function () {
			$(".js-nav-content, .js-nav-bt.close, .header__bg.close").removeClass('close');
		});
	});

		// to top
	$(document).ready(function () {
		$(window).on("scroll", function () {
			if ($(this).scrollTop() > 200) {
				$(".js-toTop").addClass('on');
			} else {
				$(".js-toTop").removeClass('on');
			}
		});
	});

	// pull down
  $(function(){
    $('.js-matchheight').matchHeight();
  });

});
